<template>
  <ODialog
    ref="dialog"
    :title="$t('components.customerCourse.actions.delete.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.delete'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
  />
</template>

<script setup lang="ts">
interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $notification, $bus, $i18n } = useNuxtApp()

const dialog = ref()
const item = ref<any>(null)

const info = computed(() => {
  return $i18n.t('components.customerCourse.actions.delete.info')
})

const open = (customerCourseItem: any) => {
  item.value = customerCourseItem
  dialog.value.open()
}

const confirm = async () => {
  if (!item.value) return

  emit('update:loading', true)

  try {
    const success = await $api.customerCourse.delete(item.value)

    if (success) {
      emit('success')

      $bus.emit.deleted('CustomerCourse', item.value)

      $notification.toast({
        title: $i18n.t('components.customerCourse.actions.delete.deletedTitle'),
        text: $i18n.t('components.customerCourse.actions.delete.deletedText'),
        variant: 'success',
      })

      emit('update:loading', false)

      return true
    }
  } catch (e) {
    console.log(e)
    $notification.error(e)
  }

  emit('update:loading', false)
}

defineExpose({
  open,
})
</script>
